export default __webpack_public_path__ + "static/media/p2.a34c8646.png";